import { ITermsConditions } from '@common/models/CMS/TermsConditions';
import Translate from '@service/Translate';
import { FC } from 'react';
import ParagraphWidget from './Widgets/ParagraphWidget';

export interface ITermsConditionsProps {
    data: ITermsConditions
}

const TermsConditions: FC<ITermsConditionsProps> = ({ data, ...props }) => {
    const { tr } = Translate;

    return (
        <section className="page-terms-conditions">
            <h2 className="terms-header">{tr("terms_conditions")} {data.name}</h2>
            <ParagraphWidget dataSource={{ text: { html: data.htmlBody?.html! } }} />
        </section>
    );
}

export default TermsConditions;
